module.exports = __webpack_public_path__ + "media/img/frontend_application/venue/microphone-icon-b86a6bd9b8ed2265dbb9b03a0603a2dc.png";